module.exports = __webpack_public_path__ + "img/package_calf.27c14713.svg";